import { StubPage } from "../StubPage.tsx";

/** Пользовательское соглашение и Политика конфиденциальности: открываются без входа, пока текст не готов. */
export function LegalPage({ title }: { title: string }) {
  return (
    <StubPage title={title}>
      <p>Документ готовится</p>
    </StubPage>
  );
}
